import { SERVICE_STATUSES } from '@adsk/acs-admin-ui-components-helpers';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import { AutocompleteOrManualAddress } from '@adsk/acs-admin-ui-components-shared-components';
var ADDRESS_INPUT_MODES = AutocompleteOrManualAddress.ADDRESS_INPUT_MODES;
export var TEMPLATE_PROJECT_TYPE = 'Template Project';
export var TEMPLATE_PROJECT_CLASSIFICATION = 'template';
export var ACS_UNIFIED_SOURCE = 'acsUnified';
export var ACTIVE_SERVICES = [SERVICE_STATUSES.ACTIVE, SERVICE_STATUSES.ACTIVATING];
export var mockedFetchDataResults = {
  accounts: [{
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: true
    },
    createProjectAccessLevels: ['accountAdmin'],
    hasAcsUnifiedProjects: true,
    id: '1',
    isAccEligible: true,
    name: 'Account A'
  }, {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: false
    },
    createProjectAccessLevels: ['accountAdmin'],
    hasAcsUnifiedProjects: true,
    id: '2',
    isAccEligible: true,
    name: 'Account B'
  }, {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: false,
      projectAdmin: true
    },
    createProjectAccessLevels: ['accountAdmin'],
    hasAcsUnifiedProjects: true,
    id: '3',
    isAccEligible: true,
    name: 'Account C'
  }, {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: false,
      projectAdmin: false
    },
    createProjectAccessLevels: ['accountAdmin'],
    hasAcsUnifiedProjects: true,
    id: '4',
    isAccEligible: true,
    name: 'Account D'
  }, {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: true
    },
    createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
    hasAcsUnifiedProjects: true,
    id: '5',
    isAccEligible: true,
    name: 'Account E'
  }, {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: true,
      projectAdmin: false
    },
    createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
    hasAcsUnifiedProjects: true,
    id: '6',
    isAccEligible: true,
    name: 'Account F'
  }, {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: false,
      projectAdmin: true
    },
    createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
    hasAcsUnifiedProjects: true,
    id: '7',
    isAccEligible: true,
    name: 'Account G'
  }, {
    accessLevels: {
      acsProjectAdmin: true,
      accountAdmin: false,
      projectAdmin: false
    },
    createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
    hasAcsUnifiedProjects: true,
    id: '8',
    isAccEligible: true,
    name: 'Account H'
  }],
  projectTypes: [{
    category: 'Category 1',
    displayName: 'Project Type 1',
    value: 'Project Type 1'
  }],
  templates: [{
    id: '1',
    name: 'Template 1'
  }, {
    id: '2',
    name: 'Template 2'
  }],
  roles: [{
    id: 'da6980e3-ce3f-45f3-9bcf-120420166075',
    name: 'BIM Manager',
    serviceAccesses: [{
      serviceName: 'projectAdministration',
      access: true
    }, {
      serviceName: 'insight',
      access: true
    }],
    products: [{
      key: 'insight',
      accessLevel: 'projectAdmin'
    }, {
      key: 'projectAdministration',
      accessLevel: 'projectAdmin'
    }]
  }, {
    id: '264e5387-488c-45fc-ad2c-ec3fdf6632c8',
    name: 'Engineer',
    serviceAccesses: [{
      serviceName: 'projectAdministration',
      access: false
    }, {
      serviceName: 'insight',
      access: false
    }],
    products: [{
      key: 'docs',
      accessLevel: 'projectMember'
    }]
  }]
};
export var mockedFilteredAccounts = [{
  accessLevels: {
    acsProjectAdmin: true,
    accountAdmin: true,
    projectAdmin: true
  },
  createProjectAccessLevels: ['accountAdmin'],
  hasAcsUnifiedProjects: true,
  id: '1',
  isAccEligible: true,
  name: 'Account A'
}, {
  accessLevels: {
    acsProjectAdmin: true,
    accountAdmin: true,
    projectAdmin: false
  },
  createProjectAccessLevels: ['accountAdmin'],
  hasAcsUnifiedProjects: true,
  id: '2',
  isAccEligible: true,
  name: 'Account B'
}, {
  accessLevels: {
    acsProjectAdmin: true,
    accountAdmin: true,
    projectAdmin: true
  },
  createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
  hasAcsUnifiedProjects: true,
  id: '5',
  isAccEligible: true,
  name: 'Account E'
}, {
  accessLevels: {
    acsProjectAdmin: true,
    accountAdmin: true,
    projectAdmin: false
  },
  createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
  hasAcsUnifiedProjects: true,
  id: '6',
  isAccEligible: true,
  name: 'Account F'
}, {
  accessLevels: {
    acsProjectAdmin: true,
    accountAdmin: false,
    projectAdmin: true
  },
  createProjectAccessLevels: ['accountAdmin', 'projectAdmin'],
  hasAcsUnifiedProjects: true,
  id: '7',
  isAccEligible: true,
  name: 'Account G'
}];
export var PROJECT_PRODUCT_MOCK = [{
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.DOCS
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.COST
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.BUILD
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.INSIGHT
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.PROJECT_ADMINISTRATION
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.MODEL_COORDINATION
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.DESIGN_COLLABORATION
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.TAKEOFF
}, {
  status: SERVICE_STATUSES.ACTIVE,
  key: PRODUCT_IDS.AUTOSPECS
}];
export var initialState = {
  accountProducts: [],
  address: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateOrProvince: '',
    postalCode: '',
    country: ''
  },
  addressInputMode: ADDRESS_INPUT_MODES.AUTOCOMPLETE,
  autocompletedAddress: '',
  endDate: null,
  isMapboxTokenActive: false,
  isSaving: false,
  jobNumber: '',
  missingRequiredField: true,
  projectName: '',
  projectValue: '',
  selectedAccount: null,
  selectedCurrency: {
    value: 'USD'
  },
  selectedPhase: null,
  selectedProjectType: null,
  selectedTemplate: null,
  selectedTimeZone: null,
  showModalConfirmation: false,
  startDate: null
};
export var TEMPLATE_TOOLTIP_LINK = 'https://help.autodesk.com/view/BUILD/ENU/?guid=Templates_About';
//# sourceMappingURL=constants.js.map